<div class="float-start">
   <div #chart class="chart-container state-vs-count"></div>
</div>
<div class="float-start stateVsCount">
   <table class="table table-xs table-borderless">
      <thead>
         <tr>
            <th class="state">{{'project.state'|translate}}</th>
            <th class="w-4rem text-right">{{'ui.quantity'|translate}}</th>
            <th class="w-6rem text-right">{{'order.amount'|translate}}</th>
            <th class="w-6rem text-right">{{'ui.totalprice'|translate}}</th>
         </tr>
      </thead>
      <tbody>
         <tr *ngFor="let stateData of data">
            <td class="state">
              <span class="badge mr-1" style="background-color: {{stateData.color}};">&nbsp;</span>
              <jbm-link-button [caption]="stateData.description" tooltip="{{'ui.show'|translate}} {{'ui.the'|translate|lowercase}} {{'entity.projects'|translate|lowercase}}"
                [showIcon]="false" (onClick)="showProjects(stateData.id)">
              </jbm-link-button>
            </td>
            <td class="w-4rem text-right">
              <jbm-inapplicable-value [value]="stateData.projectsStr"></jbm-inapplicable-value>
            </td>
            <td class="text-right">
              <jbm-inapplicable-value [value]="stateData.amountStr"></jbm-inapplicable-value>
            </td>
            <td class="w-5rem text-right">
              <jbm-inapplicable-value [value]="stateData.totalPriceStr"></jbm-inapplicable-value>
            </td>
         </tr>
      </tbody>
   </table>
</div>
